<template>
  <div v-if="isLoaded">
    <DeliverySummaryForm :src="item" :is-last=true />
  </div>
</template>

<script>
import DeliverySummaryForm from "./DeliverySummaryForm";
import deliveryMixins from '../../../mixins/delivery'

export default {
  mixins: [deliveryMixins],
  components: { DeliverySummaryForm },
  mounted() {
    var summaryId = this.$route.params.id;
    this.getRawMaterialDeliveries(summaryId);
  },
  data() {
    return {
      item: {},
      isLoaded: false,
    };
  },
  methods: {
    getRawMaterialDeliveries(id) {
      var that = this;

      this.getRawMaterialDeliveryById(id)
        .then(function (response) {
          that.item = response.data;
        })
        .catch(function () { })
        .finally(function () {
          that.isLoaded = true;
        });
    },
  },
};
</script>